const data = {
  currentIssueCover: '//www.fastcompany.com/magazine/latest-cover.jpg',
  magazineLink: 'https://www.fastcompany.com/magazine/',
  subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
  cosites: [
    {
      siteTitle: 'FastCoDesign',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488299643/fc/CO.DESIGN_BURGER_LOCKUP.svg',
      siteURL: '//www.fastcodesign.com'
    },
    {
      siteTitle: 'FastCoStudios',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488300562/fc/video_burger.svg',
      siteURL: '//www.fastcompany.com/videos'
    }
  ],
  social: {
    fastcompany: [
      {
        property: 'facebook',
        url: 'https://www.facebook.com/FastCompany/'
      },
      {
        property: 'twitter',
        url: 'https://twitter.com/fastcompany'
      },
      {
        property: 'instagram',
        url: 'https://www.instagram.com/fastcompany/'
      },
      {
        property: 'pocket',
        url: 'https://getpocket.com/explore/fastcompany.com'
      },
      {
        property: 'linkedin',
        url: 'https://www.linkedin.com/company/fast-company'
      }
    ]
  },
  collections: [
    {
      title: 'collections',
      className: 'main-menu__collections',
      isOpen: false,
      sections: [
        {
          title: 'Recommender',
          url: 'https://www.fastcompany.com/section/the-recommender',
          deck:
            'The apps, books, movies, music, TV shows, and art are inspiring our some of the most creative people in business this month'
        },
        {
          title: 'Strong Female Lead',
          url: 'https://www.fastcompany.com/section/strong-female-lead',
          deck:
            'The struggles and triumphs of prominent women in leadership positions'
        },
        {
          title: 'Platform Wars',
          url: 'https://www.fastcompany.com/section/platform-wars',
          deck:
            'The major tech ecosystems that battle for our attention and dollars'
        },
        {
          title: 'Tech Forecast',
          url: 'https://www.fastcompany.com/section/tech-forecast',
          deck: 'What’s next for hardware, software, and services'
        },
        {
          title: 'Most Innovative Companies',
          url: 'https://www.fastcompany.com/most-innovative-companies/2018',
          deck: 'Our annual guide to the businesses that matter the most'
        },
        {
          title: 'Most Creative People',
          url: 'https://www.fastcompany.com/most-creative-people/2018',
          deck:
            'Leaders who are shaping the future of business in creative ways'
        },
        {
          title: 'World Changing Ideas',
          url: 'https://www.fastcompany.com/section/world-changing-ideas',
          deck:
            'New workplaces, new food sources, new medicine--even an entirely new economic system'
        },
        {
          title: 'Innovation By Design',
          url: 'https://www.fastcompany.com/innovation-by-design/2018',
          deck: 'Celebrating the best ideas in business'
        },
        {
          title: 'FastCo.Works Studio',
          url: 'https://www.fastcompany.com/user/fastco-works',
          deck:
            "An award-winning team of journalists, designers, and videographers who tell brand stories through Fast Company's distinctive lens"
        }
      ]
    }
  ]
};

export default data;
